import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import MateriServices from '../../services/materiServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'materi/list',
  async ({ page, perPage, sort, orderBy, search, jenjang_id, mapel_id, bab_id, created_by, start_date, end_date }, thunkAPI) => {
    try {
      const response = await MateriServices.getList(
        page,
        perPage,
        sort,
        orderBy,
        search,
        jenjang_id,
        mapel_id,
        bab_id,
        created_by,
        start_date,
        end_date
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getListArchive = createAsyncThunk(
  'materi/getListArchive',
  async ({ page, perPage, sort, orderBy, search, jenjang_id, mapel_id, bab_id, created_by, start_date, end_date }, thunkAPI) => {
    try {
      const response = await MateriServices.getListArchive(page, perPage, sort, orderBy, search, jenjang_id, mapel_id, bab_id, created_by, start_date, end_date);
      // Response structure dari axios: { data: { status, message, data: {...} } }
      // Service return response.data, jadi kita dapat { status, message, data: {...} }
      // Kita return langsung karena reducer akan handle
      return response;
    } catch (error) {
      if (error.response?.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('materi/create', async (data, thunkAPI) => {
  try {
    const response = await MateriServices.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('materi/read', async (id, thunkAPI) => {
  try {
    const response = await MateriServices.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('materi/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await MateriServices.update(id, data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('materi/delete', async (id, thunkAPI) => {
  try {
    const response = await MateriServices.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getFile = createAsyncThunk('materi/getFile', async (id, thunkAPI) => {
  try {
    const response = await MateriServices.getFile(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('materi/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await MateriServices.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRatings = createAsyncThunk('materi/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await MateriServices.getRatings(id, page, perPage, sort, orderBy);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

const initialState = { isLoading: false, isFileLoading: true, file: null, ratings: null, list: [], data: [], group: [], error: [] };

const materiSlice = createSlice({
  name: 'materi',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        // Payload structure: { status, message, data: { data: [...], total: ..., ... } }
        // Kita perlu mengambil action.payload.data karena response.data sudah di-extract di thunk
        if (action.payload && action.payload.data) {
          // Jika payload sudah memiliki structure { data: {...} }, gunakan langsung
          state.list = action.payload.data;
        } else if (action.payload && Array.isArray(action.payload.data)) {
          // Fallback untuk structure yang berbeda
          state.list = action.payload;
        } else {
          state.list = { data: [], total: 0 };
        }
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getFile.pending, (state) => {
        state.isFileLoading = true;
        state.file = null;
      }),
      builder.addCase(getFile.fulfilled, (state, action) => {
        state.isFileLoading = false;
        state.file = action.payload;
      }),
      builder.addCase(getFile.rejected, (state) => {
        state.isFileLoading = false;
        state.file = null;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = materiSlice;
export default reducer;
